import Vue from 'vue';
import VuexPersistence from 'vuex-persist';
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    filters: { casino: [], slot: [] },
    results: [],
    compare: [],
    comparisonMode: false,
  },
  mutations: {
    setResults: (state, results) => {
      Vue.set(state, 'results', results);
    },

    setFilters: (state, filters) => {
      Vue.set(state, 'filters', filters);
    },
    setCompare: (state, res) => {
      Vue.set(state, 'compare', res);
    },

    setComparisonMode: (state, mode) => {
      Vue.set(state, 'comparisonMode', mode);
    },
  },

  getters: {
    results: (state) => {
      return state.results;
    },
    filters: (state) => {
      return state.filters;
    },
    compare: (state) => {
      return state.compare;
    },
    comparisonMode: (state) => {
      return state.comparisonMode;
    },
  },
});
